import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Card, Form, Button, Row } from "react-bootstrap";
import "./configDB.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { ring2 } from 'ldrs'
import AOS from 'aos';
import 'aos/dist/aos.css';
import Cookies from 'js-cookie';
import {decryptData } from "../../Auth/cryptage";



function ConfigDb() {
    ring2.register()
    const MySwal = withReactContent(Swal);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [formValues, setFormValues] = useState({
        db_connection: '',
        db_port: '',
        db_database: '',
        db_host: '',
        db_username: '',
        db_password: '',
    });

    const [formErrors, setFormErrors] = useState({});

    const validateInput = (name, value) => {
        let errors = { ...formErrors };
        if (!value) {
            errors[name] = 'This field is required';
        } else {
            delete errors[name];
        }
        setFormErrors(errors);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormValues({ ...formValues, [name]: value });
        validateInput(name, value);
    };

    useEffect(() => {
        AOS.init({ duration: 1200 });
    }, []);
    useEffect(() => {
        document.title = "GecimmoIA - Configuration de base de donnees";
    }, []);
    const handleSubmit = async (e) => {
        e.preventDefault();
        const errors = {};
        Object.keys(formValues).forEach((name) => {
            if (!formValues[name]) {
                errors[name] = 'This field is required';
            }
        });
        if (Object.keys(errors).length === 0) {
            try {
                setLoading(true);
                const token = decryptData(Cookies.get('access_token'));
                axios.post('https://api.ai.easysystem.cloud/api/connection-db',formValues, {
                    headers: {
                        'X-Custom-Token': token
                    }
                }).then((e)=>{
                    if(e.data['IsError']){
                        console.log(e.data['message'])
                        Swal.fire({
                            title: "Error!",
                            text: e.data['message'],
                            icon: "error"
                        });
                        setLoading(false);
                    }
                    if(!e.data['IsError']){
                        // console.log()(e)
                        setLoading(false);
                        if(e.data.error){
                            Swal.fire({
                                title: "Error!",
                                text: e.data.error,
                                icon: "error"
                            });
                        }
                        Swal.fire({
                            title: "Success!",
                            text: "connection",
                            icon: "success"
                        });
                        // console.log()(e.data);
                        navigate('/dashboard/permissions')
                    }
                }).catch((e)=>{
                    console.log('Error:', e.message);
                    Swal.fire({
                        title: "Error!",
                        text: e['message'],
                        icon: "error"
                    });
                });
                
                
            } catch (error) {
                // console.log()(formValues);
                setLoading(false);
                console.error('Response Error Data:', error.response.data);
                console.error('Response Error Status:', error.response.status);
                console.error('Response Error Headers:', error.response.headers);

                MySwal.fire({
                    title: "Error!",
                    text: error.response.data.message,
                    icon: "error"
                });

                if (error.response.status === 401) {
                    Swal.fire({
                        title: "Unauthorized",
                        text: "Please log in again.",
                        icon: "warning"
                    });
                }
            }
        } else {
            setFormErrors(errors);
            MySwal.fire({
                title: "Error!",
                text: "Please fill out all required fields.",
                icon: "error"
            });
        }
    };

    return (
        <Container data-aos="fade-left" fluid className="d-flex align-items-center justify-content-center mt-5">
            <Card className="dbConfigCard p-4">
                <Card.Body>
                    <h2 className="text-center mb-4">Accédez à votre base de données</h2>
                    <Form onSubmit={handleSubmit}>
                        <Row className="g-3 mb-4">
                            <Form.Group className="col-md-6" controlId="db_connection">
                                <Form.Label>Database Connection</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="db_connection"
                                    size="lg"
                                    value={formValues.db_connection}
                                    onChange={handleInputChange}
                                    isInvalid={!!formErrors.db_connection}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {formErrors.db_connection}
                                </Form.Control.Feedback>
                            </Form.Group>
    
                            <Form.Group className="col-md-6" controlId="db_host">
                                <Form.Label>Database Host</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="db_host"
                                    size="lg"
                                    value={formValues.db_host}
                                    onChange={handleInputChange}
                                    isInvalid={!!formErrors.db_host}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {formErrors.db_host}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Row>
    
                        <Row className="g-3 mb-4">
                            <Form.Group className="col-md-6" controlId="db_port">
                                <Form.Label>Database Port</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="db_port"
                                    size="lg"
                                    value={formValues.db_port}
                                    onChange={handleInputChange}
                                    isInvalid={!!formErrors.db_port}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {formErrors.db_port}
                                </Form.Control.Feedback>
                            </Form.Group>
    
                            <Form.Group className="col-md-6" controlId="db_database">
                                <Form.Label>Database Name</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="db_database"
                                    size="lg"
                                    value={formValues.db_database}
                                    onChange={handleInputChange}
                                    isInvalid={!!formErrors.db_database}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {formErrors.db_database}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Row>
    
                        <Row className="g-3 mb-4">
                            <Form.Group className="col-md-6" controlId="db_username">
                                <Form.Label>Database Username</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="db_username"
                                    size="lg"
                                    value={formValues.db_username}
                                    onChange={handleInputChange}
                                    isInvalid={!!formErrors.db_username}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {formErrors.db_username}
                                </Form.Control.Feedback>
                            </Form.Group>
    
                            <Form.Group className="col-md-6" controlId="db_password">
                                <Form.Label>Database Password</Form.Label>
                                <Form.Control
                                    type="password"
                                    name="db_password"
                                    size="lg"
                                    value={formValues.db_password}
                                    onChange={handleInputChange}
                                    isInvalid={!!formErrors.db_password}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {formErrors.db_password}
                                </Form.Control.Feedback>
                            </Form.Group>
                        </Row>
    
                        <Button className="w-100" size="lg" type="submit" variant="primary">
                            {loading ? (
                                <l-ring-2
                                    size="25"
                                    stroke="3"
                                    stroke-length="0.25"
                                    bg-opacity="0.1"
                                    speed="0.8"
                                    color="white"
                                ></l-ring-2>
                            ) : (
                                'Connecter'
                            )}
                        </Button>
                    </Form>
                </Card.Body>
            </Card>
        </Container>
    );
    
}

export default ConfigDb;
